import React from "react"
import { Layout, Flex } from "antd"
import styles from "./index.module.css"
import { Outlet } from "react-router-dom"
import classNames from "classnames"
import { Title } from "ui/Typography"
import { SettingOutlined } from "@ant-design/icons"

export const ProClientsLayout = () => {
  return (
    <Layout className={classNames(styles.layout)}>
      <Flex className="mb-l" gap="small">
        <SettingOutlined />
        <Title level={5} className={styles.clientHeaderTitle}>
          Clients
        </Title>
      </Flex>
      <Outlet />
    </Layout>
  )
}
